<template>
   <div class="dpp-desc-new" v-if="dppDescription && !dpp.hidePublicRemark" :class="{ descriptionExpanded: descriptionExpanded, showAgentInfo: showAgentInfo }">
      <div class="text-bold f3" v-if="dppDescription && !dpp.hidePublicRemark">Property description</div>
      <div class="description-container" v-if="dppDescription && !dpp.hidePublicRemark">
         <div ref="description" class="description">{{ dppDescription }}</div>
         <button type="button" v-if="showExpandLink" class="viewMore"  @click="toggleDescription">View {{ descriptionExpanded ? 'less' : 'more' }} <i :class="['icon', { 'icon-angle-down': !descriptionExpanded, 'icon-angle-up': descriptionExpanded }]"></i></button>
      </div>
      <div class="dpp-desc-mls-info" v-if="!dpp.isPrOnly">
         <div class="dpp-desc-list-agent">
            <div class="text-bold f4">Listed by</div>
            <template v-if="listingAgent">
               <div v-if="dpp.isNHS || dpp.isRDC || dpp.isRentals">Listed by {{ listingAgent }}</div>
               <div v-else>Listing Agent - {{ listingAgent }}</div>
               <div v-if="dpp.agentDetails && dpp.agentDetails.agentContactInfo">Listing Agent Contact: {{ dpp.agentDetails.agentContactInfo }}</div>
               <div v-if="dpp.officeListName">Listing Office - {{ dpp.officeListName }}</div>
            </template>
            <template v-else-if="dpp.officeListName">
               <div v-if="dpp.agentDetails && dpp.agentDetails.agentContactInfo">Listing Agent Contact: {{ dpp.agentDetails.agentContactInfo }}</div>
               <div> Listing Office - {{ dpp.officeListName }}</div>
            </template>
            <div v-if="dpp.isSold && dpp.showBuyingOffice && buyingOffice">Bought by {{ buyingOffice }}</div>
            <div v-if="basicInfoDisclaimer" v-html="basicInfoDisclaimer"></div>
            <div v-if="brokerInfo">
               <i class="icon-logo-m"></i>
               <span v-if="brokerInfoDetails">{{ brokerInfoDetails }}</span>
               <a v-if="!complianceHidePhone" :href="'tel:' + brokerInfo.dppBrokerPhone"
                  class="link">
                  <i class="icon-phone"></i>
               </a>
               <a v-if="brokerInfo.dppBrokerEmail" :href="'mailto:' + brokerInfo.dppBrokerEmail" class="link">
                  <i class="icon-envelope"></i> {{ brokerInfo.dppBrokerEmail }}
               </a>
            </div>
         </div>
         <div>
            <div class="mls-name" v-if="dpp.mlsNumber && mlsLogoSrc">
               <span> Source: </span>
               {{getMlsInfo.mlsName || ''}} <img alt="mls logo" v-if="mlsLogoSrc" loading="lazy"  :src="mlsLogoSrc" />
            </div>
            <div v-if="dpp.isNHS"><span>Source:</span>
               <a v-nhs:click @click="sendGA" class="link" :href="nhsExternalLink" target="_blank" rel="nofollow noreferrer">NewHomeSource.com</a>
               <span data-allow-mismatch="text" v-if="getUpdatedStatus.lastUpdate">Last updated:
                  {{ getUpdatedStatus.lastUpdate }}</span>
            </div>
               <div v-else-if="dpp.isRDC"><span>Source:</span>
                  <a class="link" :href="rdcExternalLink" target="_blank" rel="nofollow noreferrer">Realtor.com</a>
                  <span data-allow-mismatch="text" v-if="getUpdatedStatus.lastUpdate">Last updated:
                  {{ getUpdatedStatus.lastUpdate }}</span>
               </div>
            <div v-else-if="dpp.isRentals">
               <span>Source </span>
               <a :href="rentalUrl" v-if="rentalUrl" rel="nofollow noopener" target="_blank"><img v-if="rentalInfo.image"
                     class="img-rental-icon" :alt="getMlsInfo.mlsName + ' logo'" loading="lazy"
                     :src="rentalInfo.image" />{{ getMlsInfo.mlsName }}</a>
               <span data-allow-mismatch="text" v-if="getUpdatedStatus.lastUpdate">last updated
                  {{ getUpdatedStatus.lastUpdate }}</span>
            </div>
            <div v-else-if="dpp.mlsNumber">
               <span>MLS#{{ dpp.mlsNumber }}</span>
               <span data-allow-mismatch="text" v-if="getUpdatedStatus.lastUpdate"> &#8226; last updated
                  {{ getUpdatedStatus.lastUpdate }}</span>
            </div>
            <div v-if="lastChecked">
               <span>Movoto</span>
               <span data-allow-mismatch="text">checked {{ getMlsInfo.mlsName || 'MLS' }} for data {{ lastChecked }}</span>
            </div>
            <div v-if="showMLSCheckTimestamp && getUpdatedStatus.mlsCheckedTimestamp">
               <span data-allow-mismatch="text">Movoto refreshed data at
                  {{ $filters.formatDate(getUpdatedStatus.mlsCheckedTimestamp, { raw: true }) }}</span>
            </div>
         </div>
      </div>
   </div>
</template>
<script src="./property-descnew.js"></script>

<style lang="scss">
@use "./property-descnew.scss" as *;
</style>
